module.exports = __webpack_public_path__ + "img/BANNER_BA_PAG NUEVA - copia.73117e90.png";